import { Link, VStack, Body } from '@hover/blueprint';
import React from 'react';

const PRICING_FAQ = [
  {
    id: 1,
    title: 'Do I need to put a credit card on file when downloading HOVER?',
    content: (
      <VStack spacing={300} mb={500}>
        <Body size={500} fontWeight={400}>
          No, you can start using HOVER without putting a credit card on file.
          Your first job is included for free, but you need to add a credit card
          to your account to process subsequent jobs.
        </Body>
        <Body size={500} fontWeight={400}>
          Your first job is included for free, but you need to add a credit card
          to your account to process subsequent jobs.
        </Body>
      </VStack>
    ),
  },
  {
    id: 2,
    title: 'Is there a monthly cost associated with HOVER?',
    content: (
      <Body size={500} fontWeight={400} mb={500}>
        HOVER pricing is a combination of a SaaS-based subscription plus per-job
        transactional charges. This entitles you to advanced features and volume
        discounts. If a membership is not right for you, you have the option to
        as you go on a per-property basis.
      </Body>
    ),
  },
  {
    id: 3,
    title: 'Can I try out a membership plan for free?',
    content: (
      <Body size={500} fontWeight={400} mb={500}>
        Yes, you can start a free 30 day trial of the Measure Plan. Your first
        job is included for free, and you need to add a credit card to your
        account to process subsequent jobs.
      </Body>
    ),
  },
  {
    id: 4,
    title: 'How much does it cost to sign up with HOVER?',
    content: (
      <Body size={500} fontWeight={400} mb={500}>
        You can download the HOVER app from the App Store or Google Play at no
        cost. You’ll also receive your first property for free so you can try
        HOVER 100% risk-free.
      </Body>
    ),
  },
  {
    id: 5,
    title: 'How can I receive access to volume discounts?',
    content: (
      <Body size={500} fontWeight={400} mb={500}>
        If you sign up for one of our membership plans, you would receive per
        job discounts of $10-$15, depending on which plan you selected. Give us
        a call at (888) 868-8279 or{' '}
        <Link href="/">schedule a time to chat</Link>.
      </Body>
    ),
  },
];

export default PRICING_FAQ;
